import React from 'react';
import classnames from 'classnames';
import { useSelected } from 'slate-react';
import selectionStyles from '../../../components/SelectionRectangle/SelectionRectangle.module.css';
import type {
  ComponentProps,
  InfoBlockElement,
} from '../../../types/aha-editor';
import styles from './InfoBlock.module.css';

// React component for rendering an info block.
export const InfoBlockComponent: React.FC<ComponentProps<InfoBlockElement>> = ({
  attributes,
  element,
  children,
}) => {
  const type = element.type;
  const alignmentClass = null; // alignmentUtils.alignmentClassForData(element);
  const selected = useSelected();

  return (
    <p
      {...attributes}
      className={classnames(
        alignmentClass,
        styles.infoBlock,
        styles[`${type}Type`],
        {
          [selectionStyles.selectionRectangleSelected]: selected,
        }
      )}
    >
      <span>{children}</span>
    </p>
  );
};
